import { render } from "./AposSchema.vue?vue&type=template&id=9e71dc68&scoped=true"
import script from "./AposSchema.vue?vue&type=script&lang=js"
export * from "./AposSchema.vue?vue&type=script&lang=js"

import "./AposSchema.vue?vue&type=style&index=0&id=9e71dc68&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e71dc68"],['__file',"schema/ui/apos/components/AposSchema.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9e71dc68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9e71dc68', __exports__)) {
    api.reload('9e71dc68', __exports__)
  }
  
  module.hot.accept("./AposSchema.vue?vue&type=template&id=9e71dc68&scoped=true", () => {
    api.rerender('9e71dc68', render)
  })

}


export default __exports__